/**
 * Checks if the feature exists and whether it is enabled.
 * @param {any} flagState 
 * @returns true if enabled or false if not
 */
export const isEnabled = (flagState) => flagState === 0;
